import { useParams } from 'react-router-dom';
import { Container } from 'reactstrap';
import { TextsProvider } from './hooks/textsContext';
import EducationalBackgroundTable from './parts/EducationalBackgroundTable';
import EducationalBackgroundFormDataLoader from './parts/Loaders/EducationalBackgroundFormDataLoader';
import EducationalBackgroundLoader from './parts/Loaders/EducationalBackgroundLoader';

function EducationalBackground() {
  const { teacherId } = useParams<{ teacherId: string }>();

  return (
    <Container fluid className="mt-4">
      <TextsProvider>
        <EducationalBackgroundFormDataLoader>
          <EducationalBackgroundLoader teacherId={Number(teacherId)}>
            <EducationalBackgroundTable />
          </EducationalBackgroundLoader>
        </EducationalBackgroundFormDataLoader>
      </TextsProvider>
    </Container>
  );
}
export default EducationalBackground;
